<!-- 系统管理 -->
<template>
  <div class="flex-grow-1 d-flex flex-column overflow-hidden pa-4 gm-page">
    <PageTop />
    <TabMenu :menus="menus" v-model="tab" v-model:sub-tab="subTab" @change="onTabChange" />

    <div class="flex-grow-1 d-flex flex-column overflow-hidden min-w-0">
      <router-view />
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import PageTop from '@/components/PageTop/index.vue'
import { useRouter, useRoute } from 'vue-router'
import TabMenu from '@/components/TabMenu/index.vue'

const router = useRouter()
const route = useRoute()

const tab = ref(route.path.split('/').pop() || 'config')
const subTab = ref(route.query.subTab)

const menus = [
  {
    value: 'config',
    label: '业务配置',
    perms: ['system:businessConfig:query'],
    children: [
      { value: 'point-table', label: '设备模型', perms: ['system:businessConfig:query'] },
      { value: 'product-model', label: '设备型号', perms: ['system:businessConfig:query'] },
    ]
  },
  { value: 'menu', label: '菜单管理', perms: ['system:menu:query'] },
  { value: 'role', label: '角色管理', perms: ['system:role:query'] },
  { value: 'org', label: '组织管理', perms: ['system:org:query'] },
  { value: 'user', label: '用户管理', perms: ['system:user:query'] },
  { value: 'operlog', label: '操作日志', perms: ['monitor:operlog:list'] },
  { value: 'logininfor', label: '登录日志', perms: ['monitor:logininfor:list'] },
]

function onTabChange(tab, subTab) {
  console.log('tab change', [tab, subTab]);

  router.push({
    path: `/system-manager/${tab}`,
    query: {
      subTab: subTab ? subTab : void 0,
    }
  })
}
</script>

<style scoped lang="scss">
.tab-bar {
  border-radius: 30px 30px 0 0 !important;
  background-color: #fff !important;
  border-bottom: 1px solid #EFF4FB !important;
}
</style>
